import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { Switcher } from "../../../switcher/Switcher";

import "./WebFilterToggle.scss";

export const WebFilterToggle = ({ on, onChange }) => {
  return (
    <div className="web-filter-toggle">
      <Switcher
        id="web-filter-switch"
        label={<FormattedMessage id="web_filters" />}
        checked={on}
        onChange={onChange}
      />
    </div>
  );
};

WebFilterToggle.propTypes = {
  on: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
